export default "__VITE_ASSET__ChYn8W2T__"